import React from "react";

interface CheckboxInputProps {
  options: string[];
  selectedValues: string[];
  multiple?: boolean;
  onChange: (values: string[]) => void;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  options,
  selectedValues,
  multiple = false,
  onChange,
}) => {
  const handleChange = (option: string) => {
    if (multiple) {
      // For multiple selection
      if (selectedValues.includes(option)) {
        // If already selected, remove it
        onChange(selectedValues.filter((val) => val !== option));
      } else {
        // If not selected, add it
        onChange([...selectedValues, option]);
      }
    } else {
      onChange([option]);
    }
  };

  return (
    <div className="space-y-2 mt-2">
      {options.map((option) => {
        const isSelected = selectedValues.includes(option);
        const inputId = `option-${option}`;

        return (
          <label
            key={option}
            htmlFor={inputId}
            className="flex items-center cursor-pointer py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded w-full"
          >
            <input
              type={multiple ? "checkbox" : "radio"}
              id={inputId}
              checked={isSelected}
              onChange={() => handleChange(option)}
              className={
                multiple
                  ? "pluto-frame-checkbox w-4 h-4 mr-2 cursor-pointer"
                  : "pluto-frame-radio w-5 h-5 mr-2 cursor-pointer"
              }
            />
            <span className="ml-2 text-sm font-medium text-text-primary dark:text-text-primary-dark cursor-pointer flex-1">
              {option}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxInput;
